import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import parse from 'html-react-parser';

import "../App.css"

// components
import GlobalHeaader from '../components/GlobalHeader';
import GlobalFooter from '../components/GlobalFooter';
import BreadcrumbTrail from '../components/BreadcurmbTrail';
import Menu from '../components/Menu';
import ReportProblem from '../components/ReportProblem';

import { getLocalizedText, getTranslatedText } from './utils_v2/kumuHelper';

export default function FAQ() {

    const { t, i18n } = useTranslation('translation');
    const [faqList, setFAQList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const kumuElements = require('../api/kumu_elements.json');

    useEffect(() => {
        setIsLoading(true);
        const faqList = kumuElements.rows.filter(elm => elm.value.attributes['element type'] === 'FAQ');
        setFAQList(faqList);
        setIsLoading(false);
    }, []);

    const getData = (data) => (data !== undefined && data !== "" ? parse(data) : "Not available");

    // Sort alphabetically by label
    const sortedFAQList = faqList.sort((prev, post) =>
        getLocalizedText(prev.value.attributes, "label", i18n.language)
            .replace(/^FAQ - /, "")
            .localeCompare(
                getLocalizedText(post.value.attributes, "label", i18n.language).replace(/^FAQ - /, "")
            )
    );

    const faqData = sortedFAQList.map((faq, index) => {
        const attributes = faq.value.attributes;

        // Dynamically find all base question keys (ignore keys ending in "fr")
        const baseQuestionKeys = Object.keys(attributes)
            .filter(k =>
                k.toLowerCase().includes("question") &&
                !k.toLowerCase().endsWith("fr") &&
                !k.toLowerCase().includes("answer") // only get question keys
            );

        const questionKeys = baseQuestionKeys.map(qKey => {
            // find the corresponding answer key
            const aKey = Object.keys(attributes).find(k =>
                k.toLowerCase() === (qKey.toLowerCase() + " answer")
            );
            return { q: qKey, a: aKey };
        });

        return (
        <div key={index}>
            <h3>{getData(getTranslatedText(i18n.language, attributes.label.replace(/^FAQ - /, "")))}</h3>
            <ul className="list-unstyled">
            {questionKeys.map(({ q, a }, i) => {
                if (!q || !a) return null;

                const questionAttr = getLocalizedText(attributes, q, i18n.language);
                const answerAttr = getLocalizedText(attributes, a, i18n.language);

                if (!questionAttr || !answerAttr) return null;

                return (
                <li key={i}>
                    <details>
                    <summary>{getData(questionAttr)}</summary>
                    <p>{getData(answerAttr)}</p>
                    </details>
                </li>
                );
            })}

            {/* How to contact entry */}
            {(attributes["how to contact"] || attributes["how to contact fr"]) && (
                <li>
                    <details>
                    <summary>
                        {getData(getLocalizedText(attributes, "contact label", i18n.language))}
                    </summary>
                    <p>
                        {getData(getLocalizedText(attributes, "how to contact", i18n.language))}
                    </p>
                    </details>
                </li>
            )}
            </ul>
        </div>
        );
    });

    return (
        <div>
            <header>
                <GlobalHeaader />
                <Menu />
                <BreadcrumbTrail />
            </header>

            <main property="mainContentOfPage" className="page-content container" typeof="WebPageElement">
                <h1 property="name" id="wb-cont">
                    {t("Frequently Asked Questions")}
                </h1>
                {isLoading ? <p>{t("Loading FAQs...")}</p> : faqData}
            </main>

            <ReportProblem />
            <GlobalFooter />
        </div>
    );
}